"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.array.find");
var _toConsumableArray2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));
require("core-js/modules/es6.array.find-index");
var _auth = require("@/utils/auth");
var _eventSourcePolyfill = require("event-source-polyfill");
var _vueMarkdown = _interopRequireDefault(require("vue-markdown"));
var _clipboard = _interopRequireDefault(require("clipboard"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    VueMarkdown: _vueMarkdown.default
  },
  data: function data() {
    return {
      pageName: 'chatbot',
      formLabelWidth: '120px',
      loadingComponent: null,
      listLoading: false,
      isLoading: false,
      listData: [],
      knowledgeType: '',
      type: 'Knowledge Base',
      inputVal: '',
      recommendList: [],
      optConfig: {
        chatbotTypeList: [] // 拜访目的select
      },
      isDemo: false
    };
  },
  computed: {},
  watch: {
    isLoading: function isLoading(newValue) {
      // pc unlock 锁屏会导致页面晃动
      if (newValue) {
        this.loadingComponent = this.$loading({
          // lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0)'
        });
      } else {
        if (this.loadingComponent) {
          this.loadingComponent.close();
        }
      }
    },
    '$store.getters.language': function $storeGettersLanguage(newValue) {
      // 监听语言变更重新请求配置查询接口
      this.getLookupTypeCode(this.fetchRecommendList);
    }
  },
  mounted: function mounted() {
    var _this = this;
    this.knowledgeType = this.$route.query.knowledgeType || '';
    this.type = this.knowledgeType === '1' ? 'Knowledge Base' : 'Visit';
    this.getLookupTypeCode(this.fetchRecommendList);
    // this.fetchRecommendList()
    this.$nextTick(function () {
      _this.scrollToBottom();
      document.getElementById('scrollContainer').addEventListener('scroll', _this.handleScroll);
    });
  },
  beforeDestroy: function beforeDestroy() {
    document.getElementById('scrollContainer').removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    changeType: function changeType(val) {
      this.type = val;
      if (this.listData.length === 0) {
        this.fetchRecommendList();
      }
    },
    scrollToBottom: function scrollToBottom() {
      var container = document.getElementById('scrollContainer');
      if (container.scrollHeight) {
        // container.scrollTop = container.scrollHeight
        this.smoothScrollTo(container, container.scrollHeight);
      }
    },
    smoothScrollTo: function smoothScrollTo(container, targetScrollTop) {
      var start = container.scrollTop;
      var distance = targetScrollTop - start;
      var duration = 500; // 动画持续时间，单位毫秒
      var startTime = null;
      function step(timestamp) {
        if (!startTime) startTime = timestamp;
        var progress = timestamp - startTime;
        var ease = Math.min(1, progress / duration);
        container.scrollTop = start + distance * ease;
        if (progress < duration) {
          requestAnimationFrame(step);
        }
      }
      requestAnimationFrame(step);
    },
    handleScroll: function handleScroll() {
      var container = document.getElementById('scrollContainer');
      if (container) {
        var isAtBottom = container.scrollHeight - container.scrollTop === container.clientHeight;
        if (isAtBottom) {
          this.scrollToBottom();
        }
      }
    },
    disableSendQuestion: function disableSendQuestion() {
      if (this.inputVal === '') {
        return true;
      }
      return false;
    },
    fetchRecommendList: function fetchRecommendList() {
      var _this2 = this;
      var param = {
        'type': this.type
      };
      this.isLoading = true;
      this.$api.chatbot.chatBotRecommendList(param, this.isDemo).then(function (res) {
        _this2.isLoading = false;
        _this2.recommendList = res.data.recommend || [];
      }).catch(function (err) {
        console.log(err);
        _this2.isLoading = false;
      });
    },
    getLookupTypeCode: function getLookupTypeCode(callback) {
      var _this3 = this;
      var param = {
        configItemCodeList: ['CHATBOT_CLASS', 'CHATBOT_DEMO']
      };
      this.$api.common.getConfigItemByCode(param).then(function (res) {
        _this3.lookupList = JSON.parse(JSON.stringify(res.data || {}));
        _this3.optConfig.chatbotTypeList = _this3.lookupList['CHATBOT_CLASS'];
        if (_this3.lookupList['CHATBOT_DEMO'] && _this3.lookupList['CHATBOT_DEMO'].length > 0) {
          _this3.isDemo = false;
        } else {
          _this3.isDemo = true;
        }
        callback();
      }).catch(function () {
        console.log('Data Request Fail');
      });
    },
    clickShowSalary: function clickShowSalary() {
      console.log(this.inputVal);
      this.sendQuestion(this.inputVal);
    },
    getLastRequestIdList: function getLastRequestIdList(requestId) {
      var answerListData = JSON.parse(JSON.stringify(this.listData));
      // console.log('===answerListData====', answerListData)
      var requestIds = [];
      // eslint-disable-next-line no-return-assign
      var newAnswerListData = answerListData.filter(function (item) {
        return item.type === 'answer';
      });
      console.log('===newAnswerListData====', newAnswerListData);
      if (newAnswerListData) {
        var _ref;
        // console.log('===newAnswerListData====', newAnswerListData)
        var resultList = [];
        if (requestId !== '') {
          var requestIdIndex1 = newAnswerListData.findIndex(function (item) {
            return item['requestId'] === requestId;
          });
          if (requestIdIndex1 > 3) {
            resultList = newAnswerListData.slice(requestIdIndex1 - 3, requestIdIndex1);
          } else {
            resultList = newAnswerListData.slice(0, requestIdIndex1);
          }
        } else {
          if (newAnswerListData.length > 3) {
            var requestIdIndex2 = newAnswerListData.length;
            resultList = newAnswerListData.slice(requestIdIndex2 - 3, requestIdIndex2);
          } else {
            resultList = newAnswerListData;
          }
        }
        console.log('=====resultList====', resultList);
        requestIds = (_ref = []).concat.apply(_ref, (0, _toConsumableArray2.default)(resultList.map(function (o) {
          return o.requestId;
        })));
      }
      console.log(requestIds);
      return requestIds;
    },
    sendQuestion: function sendQuestion(question) {
      var _this4 = this;
      console.log(question);
      this.listData.push({
        'type': 'question',
        'data': question
      });
      this.inputVal = '';
      var param = {
        'question': question,
        'lastRequestIdList': this.getLastRequestIdList(''),
        'knowledgeType': this.knowledgeType,
        'type': this.type
      };
      this.$api.chatbot.chatBotQuestion(param, this.isDemo).then(function (res) {
        if (res.success) {
          var answerUrl = res.data.answerUrl;
          var requestId = res.data.requestId;
          if (answerUrl && requestId) {
            _this4.initAnswer(answerUrl, requestId);
          }
        }
        console.log(res);
        _this4.scrollToBottom();
      }).catch(function (err) {
        console.log(err);
        _this4.isLoading = false;
      });
    },
    rebuildAnswer: function rebuildAnswer(requestId) {
      var _this5 = this;
      console.log(requestId);
      var param = {
        'requestId': requestId,
        'lastRequestIdList': this.getLastRequestIdList(requestId),
        'knowledgeType': this.knowledgeType,
        'type': this.type
      };
      this.$api.chatbot.chatBotQuestionRebuild(param, this.isDemo).then(function (res) {
        if (res.success) {
          var answerUrl = res.data.answerUrl;
          var newRequestId = res.data.requestId;
          if (answerUrl && requestId) {
            _this5.initRebuildAnswer(answerUrl, newRequestId, requestId);
          }
        }
        console.log(res);
      }).catch(function (err) {
        console.log(err);
        _this5.isLoading = false;
      });
    },
    copyLink: function copyLink() {
      var _this6 = this;
      var clipboard = new _clipboard.default('.btn');
      clipboard.on('success', function (e) {
        _this6.$notify.success({
          title: '成功',
          message: '复制成功'
        });
        clipboard.destroy(); // 使用destroy可以清楚缓存
      });
      clipboard.on('error', function (e) {
        _this6.$notify.error({
          title: '失败',
          message: '复制失败'
        });
        clipboard.destroy();
      });
    },
    initAnswer: function initAnswer(answerUrl, requestId) {
      var _this7 = this;
      console.log(this.listData);
      this.listData.push({
        'type': 'answer',
        'data': '',
        'requestId': requestId,
        'event': 'add',
        'feedBackType': ''
      });
      console.log(this.listData);
      // 'https://uat-sfe.goodyear.com.cn/sfe-api-ai-chatbot/api/protected/chat/bot/answer?requestId=' + requestId
      var eventSource = new _eventSourcePolyfill.EventSourcePolyfill(answerUrl, {
        heartbeatTimeout: 30000,
        headers: {
          'token': (0, _auth.getToken)()
        }
      });
      eventSource.addEventListener('add', function (event) {
        // console.log('====this.listData====', this.listData)
        // console.log('====add====', event.data)
        var message = _this7.listData.find(function (item) {
          // eslint-disable-next-line no-return-assign
          return item.requestId === requestId;
        });
        // console.log('====message====', message)
        message.data = JSON.parse(event.data).replaceAll('\\n', '\n\n');
        message.event = 'add';
        _this7.scrollToBottom();
        // console.log(this.listData)
      });
      eventSource.addEventListener('finish', function (event) {
        // console.log('====finish====', event.data)
        var message = _this7.listData.find(function (item) {
          // eslint-disable-next-line no-return-assign
          return item.requestId === requestId;
        });
        // console.log('====message====', message)
        message.data = JSON.parse(event.data).replaceAll('\\n', '\n\n');
        message.event = 'finish';
        eventSource.close();
        _this7.scrollToBottom();
      });
      eventSource.addEventListener('error', function (event) {
        console.log('服务异常请重试并联系开发者', event);
        eventSource.close();
      });

      // eventSource.onerror(() => {
      //   eventSource.close()
      // })
    },
    initRebuildAnswer: function initRebuildAnswer(answerUrl, newRequestId, requestId) {
      var _this8 = this;
      console.log(this.listData);
      var message = this.listData.find(function (item) {
        // eslint-disable-next-line no-return-assign
        return item.requestId === requestId;
      });
      console.log('====message====', message);
      message.data = '';
      console.log(this.listData);
      var eventSource = new _eventSourcePolyfill.EventSourcePolyfill(answerUrl, {
        heartbeatTimeout: 30000,
        headers: {
          'token': (0, _auth.getToken)()
        }
      });
      eventSource.addEventListener('add', function (event) {
        // console.log('====this.listData====', this.listData)
        // console.log('====add====', event.data)
        var message = _this8.listData.find(function (item) {
          // eslint-disable-next-line no-return-assign
          return item.requestId === requestId;
        });
        // console.log('====message====', message)
        message.data = JSON.parse(event.data).replaceAll('\\n', '\n\n');
        // console.log(this.listData)
      });
      eventSource.addEventListener('finish', function (event) {
        // console.log('====finish====', event.data)
        var message = _this8.listData.find(function (item) {
          // eslint-disable-next-line no-return-assign
          return item.requestId === requestId;
        });
        // console.log('====message====', message)
        message.data = JSON.parse(event.data).replaceAll('\\n', '\n\n');
        message.requestId = newRequestId;
        eventSource.close();
      });
      eventSource.addEventListener('error', function (event) {
        console.log('服务异常请重试并联系开发者', event);
        eventSource.close();
      });

      // eventSource.onerror(() => {
      //   eventSource.close()
      // })
    },
    feedBackAnswer: function feedBackAnswer(requestId, operationType, feedBackType) {
      var _this9 = this;
      var params = {
        'feedBackType': feedBackType,
        'requestId': requestId,
        'type': this.type,
        'operationType': operationType
      };
      this.$api.chatbot.chatBotFeedBack(params, this.isDemo).then(function (res) {
        if (res.success) {
          var message = _this9.listData.find(function (item) {
            // eslint-disable-next-line no-return-assign
            return item.requestId === requestId;
          });
          // console.log('====message====', message)
          message.feedBackType = operationType === 1 ? feedBackType : '';
          _this9.$notify.success({
            title: '成功',
            message: '反馈成功'
          });
        } else {
          _this9.$notify.error({
            title: '失败',
            message: '反馈失败'
          });
        }
        console.log(res);
      }).catch(function (err) {
        console.log(err);
        _this9.isLoading = false;
      });
    },
    handleKeydown: function handleKeydown(event) {
      if (this.inputVal.trim() && event.key === 'Enter') {
        if (event.shiftKey) {
          // Shift + Enter: 插入换行符
          event.preventDefault(); // 阻止默认行为
          this.inputVal += '\n'; // 添加换行符
        } else {
          // 阻止默认行为，防止自动换行
          event.preventDefault();
          // 让输入框失去焦点
          this.$refs.inputRef.blur();
          // 单独按下 Enter: 触发发送消息
          this.clickShowSalary();
        }
      }
    },
    resetData: function resetData() {
      this.listData = [];
    }
  }
};